export default __webpack_public_path__ + "static/A4-3-8f91ba51e54f2b9b41dc8551dc731e44.jpg";